// @ts-check
import axios from 'axios'

const BASE = '/api/posthog-flags'

/** @typedef {import('./schema').operations['api_posthog_flags_retrieve']['responses']['200']['content']['application/json']} PostHogFlags */

/**
 * GET /api/posthog-flags/ — current user's PostHog flags for the active tenant.
 * @returns {Promise<PostHogFlags>}
 */
export async function getPostHogFlags() {
  const { data } = await axios.get(`${BASE}/`)
  return data
}

/**
 * GET /api/posthog-flags/?refresh=true — bust the definitions cache and return fresh flags.
 * @returns {Promise<PostHogFlags>}
 */
export async function refreshPostHogFlags() {
  const { data } = await axios.get(`${BASE}/`, {
    params: { refresh: true },
  })
  return data
}
